import {Directive, HostListener} from '@angular/core';
import {SidebarStateService} from "@app/services/util/sidebar-state.service";
import {Router} from "@angular/router";

@Directive({
  selector: '[appToggleHover]',
  standalone: false
})
export class ToggleHoverDirective {
  constructor(
    private sidebarState: SidebarStateService,
    private router: Router
  ) {}

  @HostListener('mouseenter')
  onEnter() {
    this.sidebarState.handleHover(this.router.url, true);
  }

  @HostListener('click', ['$event'])
  onClick() {
    this.sidebarState.setShrunk(false);
  }

  @HostListener('mouseleave')
  onLeave() {
    this.sidebarState.handleHover(this.router.url, false);
  }

}
